module.exports = __webpack_public_path__ + "instagram-f4edbe585b663f0512af.svg";